import { render, staticRenderFns } from "./InputPreviousVaccineMaker.vue?vue&type=template&id=06d92337&"
import script from "./InputPreviousVaccineMaker.vue?vue&type=script&lang=js&"
export * from "./InputPreviousVaccineMaker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports